import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActeDossierTableMetierService} from './acte-dossier-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-acte-dossier-table',
  templateUrl: './acte-dossier-table.component.html'
})

export class ActeDossierTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: ActeDossierTableMetierService;
  @Autowired() metierService: ActeDossierTableMetierService;

  @Input() modalAssureSelected: any;
  @Input() responseActes: any;
  @Output() responseActesEvent = new EventEmitter<any>();
  formGroup: FormGroup;
  typeRechercheCombo: any[] = [];
  placeholderInputSearch: string;

  typeInput: string;

  constructor() {
    super();
    this.cols = [
      {field: 'codeActeMedical', header: 'Code Acte Medical'},
      {field: 'libelle', header: 'Libelle '},
      {field: 'datePrestation', header: 'Date Prestation', type: () => 'date'},
      {field: 'dateRealisation', header: 'Date Realisation ', type: () => 'date'},
    ];
    this.tableActions = [];
    this.notRowActions = [];
  }

  ngOnInit(): void {
    this.initialiserTypeRechercheCombo();

    this.initFormulaire();

    this.formatTableListAddIndex(this.responseActes);

    this.typeInput = 'text';
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args};
    this.args = {...arg};
  }

  recuperationDonnees(data?: any) {
    const da = {...this.args, lazyLoadEvent: data, successMute: true, assure: this.modalAssureSelected};
    this.args = {...da};
    // tslint:disable-next-line:max-line-length
    this.metierService.requeteRecuperationListeDonnees(this.getAllRequestParam(), {...this.args}).subscribe((r_Actes) => {
      const responseActes = r_Actes.body;

      this.formatTableListAddIndex(responseActes);
      this.responseActesEvent.emit(r_Actes.body);
    });
  }

  formatTableListAddIndex(responseData) {
    if (responseData === undefined) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.dataSource = responseData.items;
    this.totalRecords = responseData.count;
    if (this.dataSource && this.dataSource.length > 0) {
      this.dataSource.forEach((dat, index) => {
        dat.id_key = index + 1;
      });
    }
  }

  initFormulaire() {
    this.formGroup = this.metierService.initialiserFormulaire(null);
  }

  initialiserTypeRechercheCombo() {
    this.placeholderInputSearch = 'Rechercher';
    this.typeRechercheCombo = [
      { label: 'Code acte médical', value: 'code_acte_médical'},
      { label: 'Libelle', value: 'libelle'},
      { label: 'Date prestation', value: 'date_prestation'},
      { label: 'Date réalisation', value: 'date_realisation'},
    ];
  }

  handleChangeTypeRecherche(event: any) {
    if (event.value === null) {
      this.placeholderInputSearch = 'Rechercher';

      this.formGroup.patchValue({ inputSearch: null });

      // fonction de recherche assuré avec les valeurs null
      this.recuperationDonnees();
    }

    if (event.value === 'code_acte_médical') {
      this.placeholderInputSearch = 'Rechercher par code acte médical';
      this.typeInput = 'text';
    }
    if (event.value === 'libelle') {
      this.placeholderInputSearch = 'Rechercher par libelle';
      this.typeInput = 'text';
    }
    if (event.value === 'date_prestation') {
      this.placeholderInputSearch = 'Rechercher par date prestation';
      this.typeInput = 'date';
    }
    if (event.value === 'date_realisation') {
      this.placeholderInputSearch = 'Rechercher par date réalisation';
      this.typeInput = 'date';
    }

    this.formGroup = this.metierService.initialiserFormulaire(this.formGroup.getRawValue());
  }

  recherchePrestation(event) {
    if (this.formGroup.getRawValue().selectTypeSearch === null) { return false; }

    // fonction de recherche assuré avec les valeurs entrées
    this.recuperationDonnees();
  }

}
